import { useMutation } from '@tanstack/react-query';
import { homeLocationQueries } from './homelocation.query';
import { queryClient } from '..';
import { EmployeeLocation } from '@/api/types';
import { api } from '@/api';

export const useCreateHomeLocationMutation = () => {
  return useMutation({
    mutationFn: (variables: Omit<EmployeeLocation, 'id'>) => api.homelocation.addHomeLocation(variables),
    onSuccess: (data: EmployeeLocation) => {
      queryClient.setQueryData(homeLocationQueries.item(data.id).queryKey, data);
    },
  });
};

export const useUpdateHomeLocationMutation = () => {
  return useMutation({
    mutationFn: (variables: Partial<EmployeeLocation> & { id: string }) =>
      api.homelocation.updateHomeLocation(variables),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(homeLocationQueries.item(variables.id).queryKey, data);
    },
  });
};
